import { LegacyTimelineSection } from './LegacyTimelineSection';

export { LegacyTimelineSection };
export default LegacyTimelineSection;
